const getParksByName = async (name) => {
  return await fetch(localStorage.getItem("api") + `/park/search/${name}`);
}

export {
    getParksByName
};